<template>
	<div>
		<v-container style="max-width:1024px">
			<v-card style="padding-left:16px; padding-right:16px; padding-top:8px; padding-bottom:8px">
				<div v-if="showSuccessAlert">
					<v-alert success :value="showSuccessAlert" transition="scale-transition">
						{{ successAlert }}
					</v-alert>

					<p class="heading-small" style="padding-top:32px">
						{{ this.lng.yourMessage }}
					</p>

					<v-card style="padding-left:32px; padding-right:32px; padding-top:16px; padding-bottom:16px;margin-bottom:16px">
						<v-layout row-sm column wrap>
							<v-flex style="font-weight:700">{{ this.lng.name }}:</v-flex>
							<v-flex>{{ name }}</v-flex>
							<v-flex xs12 style="padding-top:8px"/>
							<v-flex style="font-weight:700">{{ this.lng.mail }}:</v-flex>
							<v-flex>{{ mail }}</v-flex>
							<v-flex xs12 style="padding-top:8px"/>
							<v-flex style="font-weight:700">{{ this.lng.phonenumber }}:</v-flex>
							<v-flex>{{ tel }}</v-flex>
							<v-flex xs12 style="padding-top:8px"/>
							<v-flex style="font-weight:700">{{ this.lng.prefContact }}:</v-flex>
							<v-flex>{{ pref }}</v-flex>
							<v-flex xs12 style="padding-top:8px"/>
						</v-layout>

						<div style="padding-top:16px;">
							{{ message }}
						</div>
					</v-card>
				</div>

				<div v-if="!showSuccessAlert">
					<v-layout row-md column>
						<v-flex md4 sm12 class="long-text grey--text text--darken-1">
							<v-layout row wrap>
								<v-flex xs12 sm6 md12>
									<h1 class="heading-big grey--text text--darken-1">{{ this.lng.contact }}</h1>
									Haplabit UG (haftungsbeschränkt)<br>
									Echterstraße 8a<br>
									D-97209 Veitshöchheim<br>
									<br>
									Tel.: +49 1522 8619 710<br>
									Email:  info@hapla.eu<br>
								</v-flex>

								<v-flex xs12 sm6 md12>
									<div class="spacing-32 hidden-sm-and-down"/>
									<div class="spacing-32 hidden-sm-and-up"/>
									<div class="heading" style="padding-bottom:8px">{{ this.lng.imprint }}</div>
									Amtsgericht Würzburg. HRB 15269<br>
									Geschäftsführung: Dipl. – Ing. Harald Samoticha<br>
									USt.-ID: DE338177997<br>
								</v-flex>
							</v-layout>

							<div class="hidden-md-and-up" style="padding-top:64px"/>
						</v-flex>

						<!-- Kontaktformular -->
						<v-flex md8 sm12>
							<v-card class="elevation-0" style="padding-left:16px; padding-right:16px; padding-top:16px; padding-bottom:16px">
								<v-text-field
								v-model="name"
								:label="this.lng.name"
								prepend-icon="person"
								required
								v-bind:rules="[nameErr]"/>

								<v-text-field
								v-model="mail"
								:label="this.lng.mail"
								prepend-icon="mail"
								v-bind:rules="[mailErr]"/>

								<v-text-field
								v-model="tel"
								:label="this.lng.phonenumber"
								prepend-icon="phone"
								v-bind:rules="[telErr]"/>

								<v-layout row-sm column>
									<v-flex style="padding-top: 20px">
										<div class="grey--text text--darken-1">
											{{ this.lng.preference }}
										</div>
									</v-flex>

									<v-flex>
										<v-radio
										v-model="pref"
										:label="this.lng.phone"
										value="Rückruf (Telefon)"
										color="primary"/>
									</v-flex>

									<v-flex>
										<v-radio
										v-model="pref"
										:label="this.lng.mail"
										value="E-Mail"
										color="primary"/>
									</v-flex>
								</v-layout>

								<v-text-field
								v-model="message"
								:label="lng.message"
								multi-line
								required
								v-bind:rules="[messageErr]"/>

								<v-btn block class="accent" @click.native="send()">{{ this.lng.send }}</v-btn>
							</v-card>
						</v-flex>
					</v-layout>
				</div>
			</v-card>
		</v-container>

		<!-- white space (to keep footer away) -->
		<div v-if="!showSuccessAlert" class="spacing-128"/>
		<div v-if="showSuccessAlert" style="height:1200px"/>
	</div>
</template>

<script>
export default {
	name: 'Contact',
	created: function() {
		this.checkLng();
	},
	data () {
		return {
			name: '',
				nameErr: true,
			mail: '',
				mailErr: true,
			tel: '',
				telErr: true,
			pref: 'Rückruf (Telefon)',
			message: '',
				messageErr: true,
			showSuccessAlert: false,
			successAlert: '-',
			send: function() {
				var ok = true;
				this.showSuccessAlert = false;
				this.nameErr = true;
				this.mailErr = true;
				this.telErr = true;
				this.messageErr = true;

				if(this.name === '') {
					ok = false;
					this.nameErr = 
						(this.language === 'de') ? 'Bitte geben Sie Ihren Vor- und Nachnamen ein.' :
						(this.language === 'pl') ? 'Proszę podać swoje imię i nazwisko.' :
												   'Please enter your first and last name.';
				} else if(this.name.indexOf(' ') === -1) {
					ok = false;
					this.nameErr =
						(this.language === 'de') ? 'Bitte geben Sie sowohl Ihren Vor- als auch Ihren Nachnamen ein. Ihr Vor- und Nachname muss mit einem Leerzeichen getrennt sein.' :
						(this.language === 'pl') ? 'Podaj zarówno swoje imię, jak i nazwisko. Twoje imię i nazwisko muszą być oddzielone spacją.' :
						                           'Please enter both your first and last name.';
				}

				if(this.pref === 'Rückruf (Telefon)') {
					this.successAlert =
						(this.language === 'de') ? 'Ihre Nachricht wurde gesendet. Wir werden uns bald mit Ihnen über die von Ihnen angegebene Telefonnummer (' + this.tel + ') in Verbindung setzen.' :
						(this.language === 'pl') ? 'Twoja wiadomość została wysłana. Wkrótce skontaktujemy się z Tobą za pośrednictwem podanego numeru telefonu ('+ this.tel +').' :
						                           'Your message has been sent. We will soon get back to you via your phone nummber: ' + this.tel;
					if(this.tel === '') {
						ok = false;
						this.telErr =
							(this.language === 'de') ? 'Bitte geben Sie eine Telefonnummer an oder wählen Sie ein anderes Kontaktmittel.' :
							(this.language === 'pl') ? 'Podaj numer telefonu lub wybierz wybierz inny sposób kontaktu.' :
							                           'Please enter your phone number or choose a different contact method.';
					}
				} else {
					this.successAlert = 
						(this.language === 'de') ? 'Ihre Nachricht wurde gesendet. Wir werden uns bald mit Ihnen über die von Ihnen angegebene E-Mailadresse (' + this.mail + ') in Verbindung setzen.' :
						(this.language === 'de') ? 'Twoja wiadomość została wysłana. Wkrótce skontaktujemy się z Tobą za pośrednictwem podanego adresu e-mail ('+ this.mail +').' :
						                           'Your message has been sent. We will soon get get back to you via your e-mail: ' + this.mail;
					if(this.mail === '') {
						ok = false;
						this.mailErr = 
							(this.language === 'de') ? 'Bitte geben Sie Ihre E-Mailadresse an oder wählen Sie ein anderes Kontaktmittel.' :
							(this.language === 'pl') ? 'Podaj swój adres e-mail lub wybierz inny sposób kontaktu.' :
							                           'Please enter your e-mail address or choose a different contact method.';
					} else {
						var atPos = this.mail.indexOf('@');
						var dotPos = this.mail.indexOf('.', atPos);
						if(atPos === -1) {
							ok = false;
							this.mailErr = 
								(this.language === 'de') ? 'Bitte geben Sie eine gültige E-Mailadresse an. Berücksichtigen Sie, dass eine E-Mailadresse ein @-Zeichen enthält.' :
								(this.language === 'pl') ? 'Proszę podać poprawny adres e-mail. Pamiętaj, że adres e-mail zawiera znak @.' :
								                           'Please enter a valid e-mail address. Note that an e-mail address contains an @-symbol.';
						} else if(dotPos < atPos) {
							ok = false;
							this.mailErr = 
								(this.language === 'de') ? 'Bitte geben Sie eine gültige E-Mailadresse an. Berücksichtigen Sie, dass sich bei einer E-Mail ein Punkt hinter dem @-Zeichen befindet. Beispiel: Max.Mustermann@gmail.com' :
								(this.language === 'pl') ? 'Proszę podać poprawny adres e-mail. Weź pod uwagę, że za znakiem @ w e-mailu znajduje się kropka. Przykład: Max.Mustermann@gmail.com' :
								                           'Please enter a valid e-mail address. Note that e-mail addresses contain a dot after their @-symbol. Example: Joel.Miller@gmail.com';
						}
					}
				}

				if(this.message === '') {
					ok = false;
					this.messageErr = 
						(this.language === 'de') ? 'Bitte tippen Sie hier ihre Nachricht ein.' :
						(this.language === 'pl') ? 'Wpisz tutaj swoją wiadomość.' :
												   'Please enter your message here.';
				}

				if(ok) {
					if(this.tel === '') {
						this.tel =
							(this.language === 'de') ? '(keine Angabe)' :
							(this.language === 'pl') ? '(nieokreślony)' :
					                                   '(not specified)';
					}
					if(this.mail === '') {
						this.mail =
							(this.language === 'de') ? '(keine Angabe)' :
							(this.language === 'pl') ? '(nieokreślony)' :
						                               '(not specified)';
					}

					emailjs.send("default_service", "contact", {
						website: "Hapla",
						name: this.name,
						mail: this.mail,
						tel: this.tel,
						pref: this.pref,
						message: this.message
						// shop@hapla.eu
					});
					this.showSuccessAlert = true;
				}
			},

			// language
            checkLng: function() {
				if(this.$route.path.startsWith('/kontakt') || this.$route.path.startsWith('/contact')) {
				    setTimeout(() => { this.checkLng() }, 500);
				    if(this.language !== this.updateLngLastLng) {
				        this.updateLng();
				    }
				}
            },
            updateLng: function() {
				this.lng = this.messages[this.language];
				this.updateLngLastLng = this.language;
            },
            updateLngLastLng: '',
            lng: {},
            messages: {
				en: {
				    title: 'Contact',
				    description: 'Contact formular for Haplabit, our company specializing in the development of the "Hapla Air Quality Control System", a system meant to ensure good air quality and a comfortable indoor climate by controlling ventilation units and humidifiers over a wireless network.',

					contact: 'Contact',
					imprint: 'Imprint',
					send: 'send',

					name: 'First and last name',
					mail: 'E-Mail',
					phonenumber: 'Phone number',
					preference: 'What do you prefer?',
					phone: 'Phone',
					message: 'Message',

					prefContact: 'Preference',
					yourMessage: 'Your message:'
				},
				de: {
				    title: 'Kontakt',
				    description: 'Kontaktformular für Haplabit, unser Unternehmen, das auf die Entwicklung des „Hapla Air Quality Control System” spezialisiert ist, eines Systems, das durch die Steuerung von Lüftungsgeräten und Luftbefeuchtern über ein drahtloses Netzwerk eine gute Luftqualität und ein angenehmes Raumklima gewährleisten soll.',

					contact: 'Kontakt',
					imprint: 'Impressum',
					send: 'senden',

					name: 'Vor- und Nachname',
					mail: 'E-Mail',
					phonenumber: 'Telefonnummer',
					preference: 'Was ist Ihnen lieber?',
					phone: 'Rückruf',
					message: 'Nachricht',

					prefContact: 'Bevorzugtes Kontaktmittel',
					yourMessage: 'Ihre Nachricht:'
				},
				pl: {
				    title: 'Kontakt',
				    description: 'Formularz kontaktowy dla Haplabit, naszej firmy specjalizującej się w opracowywaniu „Hapla Air Quality Control System”, systemu mającego na celu zapewnienie dobrej jakości powietrza i komfortowego klimatu w pomieszczeniu poprzez sterowanie urządzeniami wentylacyjnymi i nawilżaczami za pośrednictwem sieci bezprzewodowej.',

					contact: 'Kontakt',
					imprint: 'Impressum',
					send: 'wyślij',

					name: 'Imię i nazwisko',
					mail: 'E-Mail',
					phonenumber: 'Numer telefonu',
					preference: 'Co wolisz?',
					phone: 'Oddzwonić',
					message: 'Wiadomość',

					prefContact: 'Preferowane medium kontaktowe',
					yourMessage: 'Twoja wiadomość:'
				}
            }
		}
	},
	props: [ 'language' ],
	metaInfo() {
		return {
			title: this.lng.title,
			titleTemplate: '%s | Haplabit',
			htmlAttrs: {
				lang: this.language,
			},
			meta: [
				{ name: 'description', content: this.lng.description },
				{ name: 'theme-color', content: '#00c853' }
			]
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
::selection {
	background: #A7F7A6;
}

.spacing-32 {
	padding-top: 32px;
}

.spacing-128 {
	padding-top: 128px;
}
</style>



// WEBPACK FOOTER //
// Kontakt.vue?1d338aa0